import { ArrowForward } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import { Link } from 'react-router';

import { url } from '../../../appRouter/url';
import { ThemaFromThemaRouter } from '../../../dtos';
import { theme } from '../../../theme/theme';
import { printCservFormat } from '../../../utils/printCservFormat';
import { formatBuchungsnummern } from '../../../utils/themaProdukte';
import { LabelValue } from '../LabelValue';
import { PendantLabelValue } from '../PendantLabelValue';
import { LeistungTag } from '../ThemaHeader/LeistungTag';
import { getOnlinePraesenzTag } from '../ThemaHeader/ThemaHeader.utils';
import { content } from './ThemaSummary.content';

export const ThemaSummary = ({
  thema,
  showTitle = false,
  showThemaLink = false,
}: {
  readonly thema: ThemaFromThemaRouter;
  readonly showTitle?: boolean;
  readonly showThemaLink?: boolean;
}) => (
  <Paper
    sx={(theme) => ({
      padding: 3,
      backgroundColor: theme.palette.text.brand,
    })}
  >
    {showTitle && (
      <Typography variant="headingXxs" color="textSecondaryOnBrand" component="p" gutterBottom>
        {thema.titel}
      </Typography>
    )}

    <Box display="flex" justifyContent="space-between" alignItems="stretch" mb={3} height={32}>
      <div className="flex gap-4">
        {getOnlinePraesenzTag(thema)}
        <LeistungTag leistungtemplates={thema.leistungstemplates} />
      </div>
      {showThemaLink && (
        <Link to={url.thema.details(thema.akaThemaId)} style={{ textDecoration: 'none', alignSelf: 'center' }}>
          <Typography color="textBrandLight" variant="labelLg">
            <Box display="flex" alignItems="center" gap={0.5}>
              Zum Thema
              <ArrowForward />
            </Box>
          </Typography>
        </Link>
      )}
    </Box>
    <Box display="grid" gap={1}>
      <LabelValue label={content.format} value={printCservFormat(thema)} color="brand" />
      <LabelValue label={content.buchungsnummer} value={formatBuchungsnummern(thema)} color="brand" />
      {thema.planungsinformation?.musskopplungReihenfolgeAkaProduktIds &&
        thema.planungsinformation.musskopplungReihenfolgeAkaProduktIds.length > 0 && (
          <LabelValue
            label={content.mussKopplung}
            value={
              <Box display="flex" gap={1}>
                {thema.planungsinformation.musskopplungReihenfolgeAkaProduktIds.map((akaProduktId) => (
                  <Link
                    to={url.thema.detailsRedirectByAkaProduktId(akaProduktId)}
                    key={akaProduktId}
                    style={{ textDecorationColor: 'white', lineHeight: theme.typography.labelLight.lineHeight }}
                  >
                    <Typography variant="labelLight" color="textPrimaryOnBrand">
                      {akaProduktId}
                    </Typography>
                  </Link>
                ))}
              </Box>
            }
            color="brand"
          />
        )}
      <PendantLabelValue thema={thema} />
    </Box>
  </Paper>
);
